// Func = limiting Scope for this file
var lastScrollTop = 0;

(function(){

	document.querySelectorAll(".privary-navigation__item").forEach(menuItem => {
		const submenu = menuItem.querySelector(".submenu");
		submenu && submenu.style.setProperty('--offset', submenu.scrollHeight + 'px');
	});

	$(document).ready(function () {

		// RELLAX JS
		if ( window.innerWidth > 767 ) {	
			const rellax = new Rellax('[data-rellax]', { center: true });
		}
		if(document.getElementById('expand-image-winter')){
			setTimeout(() => {
				document.getElementById('expand-image-winter').click();
			},200);
		}


		// Main Nav Dropdown
		/* $("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).animate({height: 'toggle', margin: '20px 0px', display: 'block'});
			$('ul.submenu',this).fadeIn(1000);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).animate({height: 'toggle', margin: '20px 0px'});
			$('ul.submenu',this).fadeOut(0.5);
		}); */

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	//Click for Menu
	document.getElementById('menu-cta-js').addEventListener('click', function(e){
		e.preventDefault();
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.getElementById('menu-text-js').innerHTML = "close";
			document.querySelector("body").classList.add('noscroll');
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('main-menu').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.getElementById('menu-text-js').innerHTML = "menu";
			document.querySelector("body").classList.remove('noscroll')
		}
	});

	// //Click for booking
	// document.getElementById('booking-cta-js').addEventListener('click', function(e){
	// 	// e.preventDefault();
	// 	if(!this.classList.contains('open')){
	// 		document.getElementById('booking-engine').classList.add('open');
	// 		document.getElementById('header').classList.add('open-booking');
	// 		this.classList.add('open');
	// 		this.innerHTML="close"
	// 		document.querySelector("body").classList.add('noscroll-m');
	// 	} else {
	// 		this.classList.remove('open');
	// 		document.getElementById('booking-engine').classList.remove('open');
	// 		document.getElementById('header').classList.remove('open-booking');
	// 		this.innerHTML="Book Now";
	// 		document.querySelector("body").classList.remove('noscroll-m')
	// 	}
	// });

	//Hover Menu
	var currentMenuItem = $("#privary-navigation a.active").parent().index();
	console.log(currentMenuItem);
	/* $(".menu-hovers .slide:eq(" + currentMenuItem + ")").addClass("active");
	$("#privary-navigation > .privary-navigation__item > a").hover(function () {
		var hoverItem = $(this).parent().index();
		console.log(hoverItem);
		$(".menu-hovers .slide").removeClass('active');
		$(".menu-hovers .slide:eq(" + hoverItem + ")").addClass("active");
	}); */

	//Mobile burger menu
	document.getElementById('burgerMenu').addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector("body").classList.add('noscroll');
			document.getElementById('text-js').innerHTML = "close";
			
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('main-menu').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.querySelector("body").classList.remove('noscroll')
			document.getElementById('text-js').innerHTML = "menu";
		}
	});

	$(function () {
		function widthScreen() {
			let widthWindow = window.innerWidth
			return widthWindow / 2
		}

		let widthHalf = widthScreen()
		let $dragmeContainer = $('.quad-slider__pictures--draggable')
		let $dragMe = $('#dragme')
		if ($dragmeContainer.length === 0 || $dragMe.length === 0) return

		let imageAfter = $dragmeContainer[0].querySelector('.quad-slider__pictures--figure:first-of-type')
		let imageBefore = $dragmeContainer[0].querySelector('.quad-slider__pictures--figure:last-of-type')
		if (imageAfter === null || imageBefore === null) return

		// create drage
		Draggable.create($dragMe, {
			type: 'left',
			bounds: $dragmeContainer,
			onDrag: updateImages,
		})

		// init aniamtion drage
		animateTo(widthHalf)

		// updated images in move drage
		function updateImages() {
		let currentLeft = $dragMe.css('left')
		let newWidth = window.innerWidth - parseInt(currentLeft)
		let captionAfter = imageAfter.querySelector('[data-tb-text="dragme"]')
		let captionBefore = imageBefore.querySelector('[data-tb-text="dragme"]')

		// animation of titles
		if (imageBefore.offsetLeft < widthHalf) {
			captionAfter.classList.remove('active')
			captionBefore.classList.add('active')
		} else if (imageBefore.offsetLeft > widthHalf) {
			captionAfter.classList.add('active')
			captionBefore.classList.remove('active')
		} else {
			captionAfter.classList.remove('active')
			captionBefore.classList.remove('active')
		}	

		// animation of images
		TweenLite.set(imageAfter, { width: currentLeft })
		TweenLite.set(imageBefore, { width: newWidth, left: currentLeft })
		}

		function animateTo(_left) {
			TweenLite.to($dragMe, 1, { left: _left, onUpdate: updateImages })
		}

		let dragmeContainer = document.querySelector('#dragme-container')
		dragmeContainer.addEventListener('click', function (event) {
			let target = event.target,
				windowScreen = window.innerWidth,
				eventToClic = windowScreen / 2
				

			if(window.innerWidth > 600) {
				if (target.getAttribute('id') === 'expand-image-summer' || target.classList.contains('figure-545037')) {
					eventToClic = (windowScreen * 65) / 100
				} else if (target.getAttribute('id') === 'expand-image-winter' || target.classList.contains('figure-545036')) {
					eventToClic = (windowScreen * 35) / 100
				}
			}else {
				if (target.getAttribute('id') === 'expand-image-summer' || target.classList.contains('figure-545037')) {
					eventToClic = windowScreen
				} else if (target.getAttribute('id') === 'expand-image-winter' || target.classList.contains('figure-545036')) {
					eventToClic = windowScreen / windowScreen
				}
			}

			animateTo(eventToClic)
		});

		// resize window
		window.addEventListener('resize', function () {
			if(window.innerWidth < 600) {
				let windowScreen = window.innerWidth
				let eventToClic = windowScreen / 2
				
				eventToClic = windowScreen / windowScreen
				animateTo(eventToClic)
			}else {
				widthHalf = widthScreen()
				animateTo(widthHalf)
			}

		})
	})
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				 document.getElementById('header').classList.add('down');
				 document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.querySelector('#gallery-category')){
			document.getElementById('header').classList.add('down')
		}
		if(document.querySelector('.sitemap')){
			document.getElementById('header').classList.add('down')
		}
		if(document.querySelector('#attractions')){
			document.getElementById('header').classList.add('down')
		}
		if(document.querySelector('.terms-and-conditions')){
			document.getElementById('header').classList.add('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

}
//For Menu Tabs
document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {

	
	btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
							room.classList.add('active');
					}
			});
	});
	if (i === 0) btn.click();
});

const select_menu = document.querySelector('#select-menu');
if (select_menu != null) {
	
	select_menu.addEventListener('change', _ => {
		document.querySelectorAll('.menu-restaurant__unitmenu').forEach(room => {
			room.classList.remove('active');
			if ( select_menu.value === 'all' || select_menu.value === room.dataset.tag ) {
					room.classList.add('active');
			}
		});
	});
}